<template>
  <div class="parties__parties">
    <div
      v-for="(party, index) in parties"
      :key="index">
      <ElTooltip class="item" effect="dark" :content="party.title" placement="right">
        <div
          :data-ec="ec"
          data-et="open_update_party_modal_link"
          :class="partyClassList(party)"
          @click.self="selectFromList(party)">
            <span data-hj-suppress>{{ getFirstCharacter(party.title) }}</span>
            <div class="parties__parties__edit-button" @click="openUpdatePartyModal(party)" v-if="!isEnvelope">
              <PencilIcon />
            </div>
        </div>
      </ElTooltip>
    </div>
    <ElTooltip class="item" effect="dark" :content="$t('createEnvelope.documentSetup.addParty')" placement="right">
      <div
        class="parties__party parties__party--add"
        @click="openAddPartyModal"
        :data-ec="ec"
        data-et="open_add_party_modal_link">
        <span>
          <PlusIcon
            height="15"
            width="15"
          />
        </span>
      </div>
    </ElTooltip>

    <AddEnvelopeParty :show="showAddEnvelopeModal" :fingerprint="fingerprint" @close="showAddEnvelopeModal = false;" />
    <AddTemplateParty :show="showAddTemplateModal" :fingerprint="fingerprint" @close="showAddTemplateModal = false;" />
    <EditTemplateParty :show="showEditTemplateModal" :party="selectedParty" :fingerprint="fingerprint" @close="showEditTemplateModal = false;" />
  </div>
</template>
<script>
import AddTemplateParty from '@/views/modals/party/AddTemplateParty.vue';
import AddEnvelopeParty from '@/views/modals/party/AddEnvelopeParty.vue';
import EditTemplateParty from '@/views/modals/party/EditTemplateParty.vue';
import { PencilIcon, PlusIcon } from '@/components/icons/fontIcons';

export default {
  components: {
    AddTemplateParty,
    AddEnvelopeParty,
    EditTemplateParty,
    PencilIcon,
    PlusIcon,
  },
  data() {
    return {
      showAddEnvelopeModal: false,
      showAddTemplateModal: false,
      showEditTemplateModal: false,
    };
  },
  props: {
    ec: String,
    isEnvelope: Boolean,
    parties: Array,
    selectedParty: Object,
    fingerprint: String,
  },
  methods: {
    partyClassList(party) {
      const defaultClass = 'parties__party';
      const isActive = this.selectedParty.id === party.id;
      const active = isActive ? ` ${defaultClass}--active` : '';
      const disabled = party.receivesCopyOnly ? ` ${defaultClass}--disabled` : '';
      return defaultClass + disabled + active;
    },
    selectFromList(selected) {
      this.$emit('select', selected);
    },
    getFirstCharacter(string) { // TODO use a Vue filter instead.
      return string ? string.charAt(0) : '?';
    },
    openUpdatePartyModal(party) {
      this.$emit('select', party);
      this.showEditTemplateModal = true;
    },
    openAddPartyModal() {
      if (this.isEnvelope) {
        this.showAddEnvelopeModal = true;
      } else {
        this.showAddTemplateModal = true;
      }
    },
  },
};
</script>

<style scoped>
.parties__party {
  color: #fff;
  background: var(--signable-secondary-2);
  border: 2px solid #253843;
  height: 52px;
  width: 52px;
  border-radius: 30px;
  position: relative;
  margin: 0 auto var(--spacing-base);
  cursor: pointer;
  transition: transform .05s ease;
  z-index: 0;
  position: relative;
}

.parties__party:hover {
  z-index: 3;
}

.parties__parties {
  padding: 15px 15px 0px 15px;
  height: 100%;
  overflow-y: auto;
  flex-basis: 102px;
}

.parties__parties {
  border-bottom-left-radius: 3px;
}

.parties__parties .parties__party:hover .parties__parties__edit-button {
  display: block;
}

.parties__parties__edit-button {
  position: absolute;
  top: -1px;
  right: -6px;
  border: 1px solid var(--signable-secondary-1);
  background: #fff;
  border-radius: 30px;
  height: 20px;
  width: 20px;
  display: none;
}

.parties__parties__edit-button:hover {
  background: var(--signable-secondary-1-shade-1);
}

.parties__parties__edit-button:hover svg {
  color: #fff;
}

.parties__parties__edit-button svg {
  color: var(--signable-secondary-1-shade-1);
  height: 10px;
}

.parties__party {
  color: #fff;
  background: var(--signable-secondary-2);
  border: 2px solid #253843;
  height: 52px;
  width: 52px;
  border-radius: 30px;
  position: relative;
  margin: 0 auto var(--spacing-base);
  cursor: pointer;
  transition: transform .05s ease;
  z-index: 0;
  position: relative;
}

.parties__party:hover {
  z-index: 3;
}

.parties__party:hover, .parties__party--selected {
  transform: scale(1.2);
}

.parties__party svg,
.parties__party span {
  pointer-events: none;
  position: absolute;
  transform: translate3d(-50%, -50%, 0);
  top: 50%;
  left: 50%;
}

.parties__party span {
  font-weight: bold;
}

.parties__party--active {
  background: var(--signable-primary-1);
  border: 2px solid #00729b;
  color: #fff;
  transition: all .25 ease;
}

.parties__party--disabled {
  opacity: 0.8;
  height: 42px;
  width: 42px;
  cursor: default;
  pointer-events: none;
}

.parties__party--disabled:hover {
  transform: scale(1);
}
</style>
